import React from "react";
import Spinner from "../Spinner/spinner";


export const LoadingScreen = ({ onComplete, offersReady = false, approachMs = 38000 }) => {
    const steps = [
      "Mobile Verified",
      "Income Profile Matched",
      "Checking Bureau Score",
      "Comparing 150+ Loan Programs",
      "Finding Best Offers",
      "Checking Instant Approval Chances",
    ];

    const [pct, setPct] = React.useState(0);

    // Phase 1: while offers are still being fetched, ease the bar toward ~90%
    // (ease-out, so it never reaches 100% on its own and never "sits" there).
    React.useEffect(() => {
      if (offersReady) return;
      const start = Date.now();
      const id = setInterval(() => {
        const t = Math.min(1, (Date.now() - start) / approachMs);
        const eased = 90 * (1 - Math.pow(1 - t, 2));
        setPct((prev) => Math.max(prev, Math.round(eased)));
      }, 60);
      return () => clearInterval(id);
    }, [offersReady, approachMs]);

    // Phase 2: offers are ready -> race the bar to 100%, then hand off (redirect).
    React.useEffect(() => {
      if (!offersReady) return;
      const id = setInterval(() => {
        setPct((prev) => {
          const next = Math.min(100, prev + 4);
          if (next >= 100) {
            clearInterval(id);
            if (onComplete) setTimeout(onComplete, 250);
          }
          return next;
        });
      }, 20);
      return () => clearInterval(id);
    }, [offersReady, onComplete]);

    // Tick each item as the bar passes its share of the progress.
    const doneCount = Math.ceil((pct / 100) * steps.length);

    return (
      <div className="dm-checking-v9 absolute top-0 left-0 right-0 mx-auto w-full max-w-[400px] min-h-screen bg-white flex flex-col px-4 pb-[130px]">
        <h2 className="dm-type-eligibility text-[18px] mt-[60px] text-[#1b1b1b]">
          Finding your loan offers…
        </h2>
        <p className="font-atkinson text-[13px] text-[#8b8b8b] mt-3">
          Checking lenders that may suit your profile.
        </p>

        <div className="mt-9">
          {steps.map((s, i) => {
            const done = i < doneCount;
            return (
              <div
                key={s}
                className={"flex items-center gap-4 py-[13px] " + (i > 0 ? "border-t border-[#ededed]" : "")}
              >
                <span
                  className={
                    "w-[22px] h-[22px] rounded-full flex items-center justify-center flex-none transition-colors " +
                    (done ? "bg-[#12f280]" : "bg-[#e8e8e8]")
                  }
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12l5 5L20 6" />
                  </svg>
                </span>
                <span className="font-atkinson font-bold text-[14px] text-[#1b1b1b]">{s}</span>
              </div>
            );
          })}
        </div>

        {/* progress bar pinned to the bottom of the viewport -> always visible */}
        <div className="fixed bottom-0 left-0 right-0 z-50 mx-auto w-full max-w-[400px] bg-white px-4 pt-4 pb-6 border-t border-[#f0f0f0]">
          <div className="h-[7px] rounded-[6px] bg-[#c9f7e0] overflow-hidden">
            <div
              className="h-full bg-[#12f280] rounded-[6px] transition-[width] duration-100"
              style={{ width: `${pct}%` }}
            />
          </div>
          <p className="font-atkinson text-[18px] text-[#8b8b8b] mt-[12px]">{pct}% Complete</p>
        </div>
      </div>
    );
  };
